"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.putTariffPlanStatusV1 = exports.putPublishV1 = exports.putBoardapprovalV1 = exports.getTariffPlanRevisionsV1 = exports.createTariffPlanV1 = exports.putTariffplansV1 = exports.getTariffplansV1 = exports.deleteTariffPlanV1 = exports.putSalesperiodV1 = exports.getTariffplanconditionsV1 = exports.getProductsV1 = exports.getProductV1 = exports.createTariffPlanGroupV1 = exports.getTariffPlanGroupsV1 = exports.putTariffplangroupsV1 = exports.deleteTariffPlanGroupV1 = exports.createEnergyTaxRecordV1 = exports.getDefaultPeriodsV1 = exports.getHealth = exports.getDynamicPricesByDateV1 = exports.getDynamicPrices = exports.getDynamicPricesAvailability = exports.getDynamicPricesByDateV2 = void 0;
/**
 * Gets dynamic prices for a specific date.
 * @param data The data for the request.
 * @param data.date The query date, this is in local timezone: Europe/Amsterdam.
 * @returns GetDynamicPricesByDateResponse OK
 * @throws ApiError
 */
const getDynamicPricesByDateV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/{date}/v2',
        path: {
            date: data.date
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPricesByDateV2 = getDynamicPricesByDateV2;
/**
 * Gets for which period dynamic prices are available.
 * @returns GetDynamicPricesAvailabilityResponse OK
 * @throws ApiError
 */
const getDynamicPricesAvailability = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/availability/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPricesAvailability = getDynamicPricesAvailability;
/**
 * Gets dynamic prices for yesterday, today and tomorrow.
 * @returns GetDynamicPricesResponse OK
 * @throws ApiError
 */
const getDynamicPrices = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPrices = getDynamicPrices;
/**
 * @deprecated
 * Gets dynamic prices for a specific date.
 * @param data The data for the request.
 * @param data.date The query date, this is in local timezone: Europe/Amsterdam.
 * @returns GetDynamicPricesByDateResponse OK
 * @throws ApiError
 */
const getDynamicPricesByDateV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/dynamic-prices/v1/{date}',
        path: {
            date: data.date
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDynamicPricesByDateV1 = getDynamicPricesByDateV1;
/**
 * Check service availability
 * @returns GetHealthResponse OK
 * @throws ApiError
 */
const getHealth = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/health',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getHealth = getHealth;
/**
 * Gets the default sales and operational periods for a given start date and duration
 * @param data The data for the request.
 * @param data.salesPeriodStartDate
 * @param data.durationInMonths
 * @returns getDefaultPeriodsResponse OK
 * @throws ApiError
 */
const getDefaultPeriodsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/default-periods/v1',
        query: {
            salesPeriodStartDate: data.salesPeriodStartDate,
            durationInMonths: data.durationInMonths
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getDefaultPeriodsV1 = getDefaultPeriodsV1;
/**
 * Create a new energy tax record
 * @returns createEnergyTaxRecordResponse OK
 * @throws ApiError
 */
const createEnergyTaxRecordV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/tariffmanagement/tariff-management-app/energy-tax-records/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.createEnergyTaxRecordV1 = createEnergyTaxRecordV1;
/**
 * Delete a tariff plan group within a product
 * @returns unknown OK
 * @throws ApiError
 */
const deleteTariffPlanGroupV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'DELETE',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plan-groups/{tariffPlanGroupId}/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.deleteTariffPlanGroupV1 = deleteTariffPlanGroupV1;
/**
 * Update an existing tariff plan group's default conditions
 * @param data The data for the request.
 * @param data.productId
 * @param data.tariffPlanGroupId
 * @param data.requestBody
 * @returns createTariffPlanGroupDefaultConditionsResponse OK
 * @throws ApiError
 */
const putTariffplangroupsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plan-groups/{tariffPlanGroupId}/v1',
        path: {
            productId: data.productId,
            tariffPlanGroupId: data.tariffPlanGroupId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putTariffplangroupsV1 = putTariffplangroupsV1;
/**
 * Get all tariff plan groups linked to a product including tariff plans
 * @param data The data for the request.
 * @param data.productId
 * @param data.managementApproval Filter tariff plan groups by management approval status (comma-separated values)
 * @param data.tariffPlanStatus Filter tariff plan groups by tariff plan status (comma-separated values)
 * @param data.durationInYearsFrom Filter products by duration in years (inclusive)
 * @param data.durationInYearsTo Filter products by duration in years (inclusive)
 * @param data.segment Filter tariff plan groups by segment type (comma-separated values)
 * @returns getTariffPlanGroupsResponse OK
 * @throws ApiError
 */
const getTariffPlanGroupsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plan-groups/v1',
        path: {
            productId: data.productId
        },
        query: {
            managementApproval: data.managementApproval,
            tariffPlanStatus: data.tariffPlanStatus,
            durationInYearsFrom: data.durationInYearsFrom,
            durationInYearsTo: data.durationInYearsTo,
            segment: data.segment
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTariffPlanGroupsV1 = getTariffPlanGroupsV1;
/**
 * Create a new tariff plan group within a product
 * @param data The data for the request.
 * @param data.productId
 * @param data.requestBody
 * @returns createTariffPlanGroupResponse OK
 * @throws ApiError
 */
const createTariffPlanGroupV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/tariff-plan-groups/v1',
        path: {
            productId: data.productId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.createTariffPlanGroupV1 = createTariffPlanGroupV1;
/**
 * Gets a single product
 * @returns Product OK
 * @throws ApiError
 */
const getProductV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/products/{productId}/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProductV1 = getProductV1;
/**
 * Gets all products
 * @param data The data for the request.
 * @param data.energyType Filter products by energy type (comma-separated values)
 * @param data.segment Filter products by segment (comma-separated values)
 * @param data.tariffPlanStatus Filter products by tariff plan status (comma-separated values)
 * @param data.managementApproval Filter products by management approval status (comma-separated values)
 * @param data.durationInYearsFrom Filter products by duration in years (inclusive)
 * @param data.durationInYearsTo Filter products by duration in years (inclusive)
 * @returns GetProductsResponse OK
 * @throws ApiError
 */
const getProductsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/products/v1',
        query: {
            energyType: data.energyType,
            segment: data.segment,
            tariffPlanStatus: data.tariffPlanStatus,
            managementApproval: data.managementApproval,
            durationInYearsFrom: data.durationInYearsFrom,
            durationInYearsTo: data.durationInYearsTo
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProductsV1 = getProductsV1;
/**
 * Get active tariff plan conditions by brand & segment
 * @param data The data for the request.
 * @param data.brand Filter tariff plan conditions by brand
 * @param data.segment Filter tariff plan conditions by segment
 * @returns getTariffPlanConditionsResponse OK
 * @throws ApiError
 */
const getTariffplanconditionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/tariff-plan-conditions/v1',
        query: {
            brand: data.brand,
            segment: data.segment
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTariffplanconditionsV1 = getTariffplanconditionsV1;
/**
 * Updates the end date of the sales period of a tariff plan within a tariff plan group
 * @param data The data for the request.
 * @param data.tariffPlanGroupId
 * @param data.tariffPlanId
 * @param data.requestBody
 * @returns updateTariffPlanSalesPeriodResponse OK
 * @throws ApiError
 */
const putSalesperiodV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plan-groups/{tariffPlanGroupId}/tariff-plans/{tariffPlanId}/sales-period/v1',
        path: {
            tariffPlanGroupId: data.tariffPlanGroupId,
            tariffPlanId: data.tariffPlanId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putSalesperiodV1 = putSalesperiodV1;
/**
 * Delete a tariff plan within a tariffPlanGroup
 * @param data The data for the request.
 * @param data.tariffPlanGroupId
 * @param data.tariffPlanId
 * @returns unknown OK
 * @throws ApiError
 */
const deleteTariffPlanV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'DELETE',
        url: '/tariffmanagement/tariff-management-app/tariff-plan-groups/{tariffPlanGroupId}/tariff-plans/{tariffPlanId}/v1',
        path: {
            tariffPlanGroupId: data.tariffPlanGroupId,
            tariffPlanId: data.tariffPlanId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.deleteTariffPlanV1 = deleteTariffPlanV1;
/**
 * Get single tariff plan within a tariff plan group
 * @param data The data for the request.
 * @param data.tariffPlanGroupId
 * @param data.tariffPlanId
 * @returns getTariffPlanResponse OK
 * @throws ApiError
 */
const getTariffplansV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/tariff-plan-groups/{tariffPlanGroupId}/tariff-plans/{tariffPlanId}/v1',
        path: {
            tariffPlanGroupId: data.tariffPlanGroupId,
            tariffPlanId: data.tariffPlanId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTariffplansV1 = getTariffplansV1;
/**
 * Edit a tariff plan within a tariffPlanGroup
 * @param data The data for the request.
 * @param data.tariffPlanGroupId
 * @param data.tariffPlanId
 * @param data.requestBody
 * @returns editTariffPlanResponse OK
 * @throws ApiError
 */
const putTariffplansV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plan-groups/{tariffPlanGroupId}/tariff-plans/{tariffPlanId}/v1',
        path: {
            tariffPlanGroupId: data.tariffPlanGroupId,
            tariffPlanId: data.tariffPlanId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putTariffplansV1 = putTariffplansV1;
/**
 * Create a tariff plan within a tariff plan group
 * @param data The data for the request.
 * @param data.tariffPlanGroupId
 * @param data.requestBody
 * @returns createTariffPlanResponse OK
 * @throws ApiError
 */
const createTariffPlanV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/tariffmanagement/tariff-management-app/tariff-plan-groups/{tariffPlanGroupId}/tariff-plans/v1',
        path: {
            tariffPlanGroupId: data.tariffPlanGroupId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.createTariffPlanV1 = createTariffPlanV1;
/**
 * Get all revisions for a specific tariff plan
 * @param data The data for the request.
 * @param data.tariffPlanId
 * @returns getTariffPlanRevisionsResponse OK
 * @throws ApiError
 */
const getTariffPlanRevisionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/tariffmanagement/tariff-management-app/tariff-plans/{tariffPlanId}/revisions/v1',
        path: {
            tariffPlanId: data.tariffPlanId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTariffPlanRevisionsV1 = getTariffPlanRevisionsV1;
/**
 * Give board approval to one or more tariff plans
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const putBoardapprovalV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plans/board-approval/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putBoardapprovalV1 = putBoardapprovalV1;
/**
 * Publish one or more tariff plans
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const putPublishV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plans/publish/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putPublishV1 = putPublishV1;
/**
 * Update the status of one or more tariff plans
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const putTariffPlanStatusV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/tariffmanagement/tariff-management-app/tariff-plans/status/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putTariffPlanStatusV1 = putTariffPlanStatusV1;
